class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    })
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach(animation => animation.play());
    } else {
      this.animations.forEach(animation => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.menu = document.querySelector('.header__inline-menu');
    this.submenu = this.querySelector('.header__submenu');
    this.timeoutRemoveClass = null;
    this.timeoutRemoveAttr = null;

    // Allow for submenu open on hover
    this.mainDetailsToggle.addEventListener('mouseover', this.onMouseOver.bind(this));
    this.mainDetailsToggle.addEventListener('mouseout', this.onMouseOut.bind(this));
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty('--header-bottom-position-desktop', `${Math.floor(this.header.getBoundingClientRect().bottom)}px`);
  }

  onMouseOver() {
    // prevent submenu from getting "stuck"
    if (this.timeoutRemoveClass) clearTimeout(this.timeoutRemoveClass);
    if (this.timeoutRemoveAttr) clearTimeout(this.timeoutRemoveAttr);
    if (!this.header.classList.contains('submenu-open')) this.header.classList.add('submenu-open');
    this.mainDetailsToggle.setAttribute('open', '');
    this.mainDetailsToggle.classList.add('submenu-opening');
  }

  onMouseOut() {
    // if the user hovers over the menu element, don't close
    if (this.mainDetailsToggle.matches(':hover') || this.submenu.matches(':hover')) return;

    // delay to improve user experience
    this.timeoutRemoveClass = setTimeout(() => {
      this.mainDetailsToggle.classList.remove('submenu-opening');
    }, 250);
    this.timeoutRemoveAttr = setTimeout(() => {
      this.mainDetailsToggle.removeAttribute("open");
    }, 500);
  }

  showSubmenu() {

  }
}

customElements.define('header-menu', HeaderMenu);
